export const AUDIT_LOG = 'AUDIT_LOG';
export const AUDIT_LOG_SK = 'AUDIT_LOG_SK';
export const AUDIT_LOG_DETAIL = 'AUDIT_LOG_DETAIL';
export const AUDIT_LOG_RESET = 'AUDIT_LOG_RESET';

